import React from "react";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
} from "react-icons/fa";

function ContactCard({ icon, title, children, link }) {
  return (
    <div
      className="flex items-start gap-4 p-6 bg-white rounded-2xl shadow-sm border border-gray-100 
                    transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-orange-100 text-orange-600 text-xl">
        {icon}
      </div>
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-1">{title}</h3>
        {link ? (
          <a
            href={link}
            className="text-gray-600 hover:text-orange-600 transition-colors"
          >
            {children}
          </a>
        ) : (
          <div className="text-gray-600 leading-relaxed">{children}</div>
        )}
      </div>
    </div>
  );
}

export default function Contact() {
  return (
    <section className="bg-white" id="contact-us">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        {/* Nagłówek */}
        <div className="mb-10 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Gdzie nas znajdziesz?
          </h1>
        </div>

        {/* Główny kontener */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          {/* Mapa */}
          <div className="relative">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3009.333714470894!2d20.5948529768725!3d50.926066153004435!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471829545e25b0cf%3A0xcceebc2ac8ebdeb6!2sAnatomia%20Smaku!5e1!3m2!1spl!2spl!4v1744572097386!5m2!1spl!2spl"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              className="w-full h-96 lg:h-[500px] rounded-2xl shadow-xl filter grayscale hover:grayscale-0 transition-all duration-500"
            />
          </div>

          {/* Informacje kontaktowe */}
          <div className="space-y-6">
            <ContactCard
              icon={<FaMapMarkerAlt className="text-orange-500 text-2xl" />}
              title="Adres"
            >
              Kostomłoty I ul. Podmiejska 187a
              <br />
              26-085 Miedziana Góra
            </ContactCard>

            <ContactCard
              icon={<FaPhoneAlt className="text-orange-500 text-2xl" />}
              title="Telefon"
            >
              <div className="text-gray-600 leading-relaxed">
                <p>
                  Zamówienia –{" "}
                  <a
                    href="tel:504 784 337"
                    className="hover:text-orange-600 transition-colors"
                  >
                    504 784 337
                  </a>
                </p>
                <p>
                  Rafał Boroński –{" "}
                  <a
                    href="tel:504 769 855"
                    className="hover:text-orange-600 transition-colors"
                  >
                    504 769 855
                  </a>
                </p>
              </div>
            </ContactCard>

            <ContactCard
              icon={<FaEnvelope className="text-orange-500 text-2xl" />}
              title="Email"
              link="mailto:info@anatomiasmaku.pl"
            >
              info@anatomiasmaku.pl
            </ContactCard>

            <ContactCard
              icon={<FaClock className="text-orange-500 text-2xl" />}
              title="Godziny otwarcia"
            >
              Pon-Pt: 9:00 - 14:00
              <br />
              Sob: Zamknięte
              <br />
              Niedz: Zamknięte
            </ContactCard>
          </div>
        </div>
      </div>
    </section>
  );
}
